import React, { useEffect, useState } from 'react';
export default function ScrollProgress() {
  const [p, setP] = useState(0);
  useEffect(() => {
    const fn = () => { const s = window.scrollY, t = document.documentElement.scrollHeight - window.innerHeight; setP((s/t)*100); };
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);
  return <div style={{ position:'fixed', top:0, left:0, height:'2px', width:p+'%', background:'#C8941A', zIndex:99999, transition:'width 0.1s', pointerEvents:'none' }} />;
}
